// src/utils/metalNameFixer.js

const metalNameMap = {
  "SIlvar( Patty ) tukda": "Silver( Patty ) tukda",
  // Add more if needed
};

export const getDisplayName = (metalName) => {
  return metalNameMap[metalName] || metalName;
};
